module.exports = __webpack_public_path__ + "media/images/christinasage-sm-c346d47f82aeba1b1ce2c002651389a4.jpg";